import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from '@els/els-react--checkbox';
import RsTableRow from '@Pages/RetroSynthesis/components/RsTable/RsTableRow';
import { RouteType } from '@Pages/RetroSynthesis/constants';
import RsBuildingBlocks from '@Pages/RetroSynthesis/components/RsBuildingBlocks';
import SimpleSpinner from '@Components/Results/utils/SimpleSpinner';
import Result from '@Components/Results/Result';

function PlanPredictedItem({
  selected,
  index,
  routeType,
  routeLayout = [],
  result,
  selectedStepExamplesSearchData,
  onSelectionChange = () => null,
}) {
  const leafRouteItems = routeLayout.filter((routeItem) => routeItem.leafNode);
  const structures = leafRouteItems.map((routeItem) => routeItem.substance);
  const exampleReactionId = routeLayout?.[0]?.examples?.[0]?.reactionId;
  const checkboxKey = exampleReactionId || index?.id || routeLayout?.[0]?.id;
  const checkboxId = `add-step-predicted-checkbox-${checkboxKey ?? 'unknown'}`;
  const checkboxLabel = exampleReactionId ? `Select predicted reaction ${exampleReactionId}` : 'Select predicted reaction step';

  return (
    <RsTableRow>
      <td className="c-els-table__cell c-els-table__basic-cell plan-predicted-items__checkbox-column">
        <Checkbox
          id={checkboxId}
          label={checkboxLabel}
          shouldHideLabel
          data-e2e={checkboxId}
          checked={selected}
          onChange={(event) => {
            const { checked } = event.currentTarget;
            onSelectionChange({ index, checked });
          }}
          aria-checked={selected}
        />
      </td>
      <td className="c-els-table__cell c-els-table__basic-cell plan-predicted-items__substances-column">
        <RsBuildingBlocks routeType={routeType} structures={structures} showOptions={false} showZoom={false} showStepsCount={false} />
      </td>
      <td className="c-els-table__cell c-els-table__basic-cell plan-predicted-items__examples-column">
        {result ? (
          // rx-list
          <div className="rx-list--reactions plan-predicted-items__examples">
            <Result
              key={result.id}
              context="reactions"
              hideCheckbox
              result={result}
              metadata={{
                ...selectedStepExamplesSearchData,
                fromDocuments: true, // limit functionality, create a separate flag
                expandConditions: true,
              }}
              showToolbar={false}
              displayAllConditions={false}
            />
          </div>
        ) : (
          <SimpleSpinner />
        )}
      </td>
    </RsTableRow>
  );
}

PlanPredictedItem.propTypes = {
  index: PropTypes.object,
  routeType: PropTypes.oneOf(RouteType.allTypes),
  routeLayout: PropTypes.array,
  selected: PropTypes.bool,
  onSelectionChange: PropTypes.func,
  result: PropTypes.object,
  selectedStepExamplesSearchData: PropTypes.object,
};

export default PlanPredictedItem;
